<template>
  <div v-if="isMobile" class="sticky bottom-6 z-20 pointer-events-none">
    <Transition name="save-toast" mode="out-in">
      <div
        v-if="dirty"
        key="dirty"
        class="save-bar-in pointer-events-auto flex items-center gap-2.5 rounded-2xl py-2 ps-3 pe-2 bg-[rgba(24,24,27,.92)] backdrop-blur-md shadow-[0_12px_32px_rgba(0,0,0,.3)]"
      >
        <span class="w-[7px] h-[7px] rounded-full bg-amber-400 flex-none" />
        <span class="flex-1 text-xs text-white/85">יש שינויים שלא נשמרו</span>
        <button
          type="button"
          class="pointer-events-auto flex items-center gap-2 px-5 py-2 rounded-xl bg-primary text-white text-xs font-semibold disabled:opacity-60"
          :disabled="loading || disabled"
          @click="$emit('save')"
        >
          <i v-if="loading" class="pi pi-spinner pi-spin text-xs" />
          שמירה
        </button>
      </div>
      <div v-else-if="saved" key="saved" class="flex justify-center">
        <div class="saved-pop pointer-events-auto flex items-center gap-2 px-5 py-2 rounded-full bg-green-700 text-white text-xs font-semibold shadow-[0_8px_24px_rgba(21,128,61,.35)]">
          <i class="pi pi-check text-xs" /> השינויים נשמרו
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { useResponsive } from '@app/composables/responsive';

defineProps<{
  dirty: boolean;
  saved?: boolean;
  loading?: boolean;
  disabled?: boolean;
}>();
defineEmits<{ save: [] }>();

// The floating save bar is the mobile treatment. On desktop, the settings page
// surfaces the save action as a header-end button (see Configurations.vue).
const { isMobile } = useResponsive();
</script>

<style scoped>
/* Enter is handled by each state's own keyframe (save-bar-in / saved-pop);
   the Transition only owns the exit so the saved toast animates out. */
.save-toast-leave-active {
  transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.4, 0, 1, 1);
}

.save-toast-leave-to {
  opacity: 0;
  transform: translateY(16px) scale(0.94);
}

.save-bar-in {
  animation: save-bar-in 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.saved-pop {
  animation: saved-pop 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

@keyframes save-bar-in {
  0% { transform: translateY(72px) scale(0.92); opacity: 0; }
  60% { transform: translateY(-4px) scale(1.01); opacity: 1; }
  100% { transform: translateY(0) scale(1); opacity: 1; }
}

@keyframes saved-pop {
  0% { transform: scale(0.6); opacity: 0; }
  70% { transform: scale(1.15); }
  100% { transform: scale(1); opacity: 1; }
}
</style>
